import React, { useState } from 'react';
import Select from 'react-select';

const BranchModal = ({ isOpen, setIsOpen }) => {
    // Move the useState hook to the top of the component
    const [openingHours, setOpeningHours] = useState([{ date: '', fromTime: '', toTime: '' }]);

    // Only return the modal if `isOpen` is true
    if (!isOpen) return null;

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    const serviceOptions = [
        { value: 'service1', label: 'Service 1' },
        { value: 'service2', label: 'Service 2' },
    ];

    const handleAddOpeningHour = () => {
        setOpeningHours([...openingHours, { date: '', fromTime: '', toTime: '' }]);
    };

    const handleChangeOpeningHour = (index, field, value) => {
        const newOpeningHours = [...openingHours];
        newOpeningHours[index][field] = value;
        setOpeningHours(newOpeningHours);
    };

    const handleRemoveOpeningHour = (index) => {
        const newOpeningHours = openingHours.filter((_, i) => i !== index);
        setOpeningHours(newOpeningHours);
    };


    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Branches</h2>
                <form className="oms-modal-form">
                    <div className="oms-form-group">
                        <label htmlFor="branch-name" className="oms-form-label">
                            Branch Name
                        </label>
                        <input type="text" id="branch-name" placeholder="Enter branch name" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="location" className="oms-form-label">
                            Location
                        </label>
                        <input type="text" id="location" placeholder="Enter location" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="primary-contact" className="oms-form-label">
                            Primary Contact
                        </label>
                        <input type="tel" id="primary-contact" placeholder="Enter primary contact" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="secondary-contact" className="oms-form-label">
                            Secondary Contact
                        </label>
                        <input type="tel" id="secondary-contact" placeholder="Enter secondary contact" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="email" className="oms-form-label">
                            Email
                        </label>
                        <input type="email" id="email" placeholder="Enter email" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="service" className="oms-form-label">
                            Service/Facility Offered
                        </label>
                        <Select options={serviceOptions} placeholder="Select service/facility" />
                    </div>
                    {openingHours.map((_, index) => (
                        <div className="oms-form-group" key={index}>
                            <label className="oms-form-label">
                                Opening Hour {index + 1}
                                {/* Conditionally render the trash icon */}
                                {index !== 0 && (
                                    <button
                                        type="button"
                                        className="trash-button"
                                        onClick={() => handleRemoveOpeningHour(index)}
                                        title="Remove opening hour"
                                    >
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                )}
                            </label>
                            <div className="oms-form-inline">
                                <div className="oms-form-field">
                                    <label htmlFor={`date-${index}`} className="oms-form-label">
                                        Date
                                    </label>
                                    <input
                                        id={`date-${index}`}
                                        type="date"
                                        placeholder="Select date"
                                        value={openingHours[index].date}
                                        onChange={(e) => handleChangeOpeningHour(index, 'date', e.target.value)}
                                    />
                                </div>
                                <div className="oms-form-field">
                                    <label htmlFor={`fromTime-${index}`} className="oms-form-label">
                                        From Time
                                    </label>
                                    <input
                                        id={`fromTime-${index}`}
                                        type="time"
                                        placeholder="From Time"
                                        value={openingHours[index].fromTime}
                                        onChange={(e) => handleChangeOpeningHour(index, 'fromTime', e.target.value)}
                                    />
                                </div>
                                <div className="oms-form-field">
                                    <label htmlFor={`toTime-${index}`} className="oms-form-label">
                                        To Time
                                    </label>
                                    <input
                                        id={`toTime-${index}`}
                                        type="time"
                                        placeholder="To Time"
                                        value={openingHours[index].toTime}
                                        onChange={(e) => handleChangeOpeningHour(index, 'toTime', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                    <button type="button" className="add-opening-button" onClick={handleAddOpeningHour}>
                        Add More Opening Hours
                    </button>
                    <div className="oms-form-group">
                        <label htmlFor="subscription-fee" className="oms-form-label">
                            Service/Subscription Fee (Monthly)
                        </label>
                        <input type="number" id="subscription-fee" placeholder="Enter fee" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="registration-fee" className="oms-form-label">
                            Registration Fee
                        </label>
                        <Select options={statusOptions} placeholder="Select registration fee" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="parking-available" className="oms-form-label">
                            Parking Available
                        </label>
                        <Select options={statusOptions} placeholder="Select parking availability" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions} placeholder="Select status" />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BranchModal;
